import * as React from "react";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { Objects } from "../../../../../react-core/Utils/Objects";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { AccountRoleStore, ClientAccountStore, UserStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { productMap } from "../SinglePaymentTransferWizard/Resource/Content";
import { BuyAction } from "./Action/BuyAction";
import { BuyInvestment } from "./Components/BuyInvestment/BuyInvestment";
import { BuyOrderSetup } from "./Components/OrderSetup/OrderSetup";
import { Review } from "./Components/Review/Review";
import { buyStepperName } from "./Resource/Content";
import { BuyStore } from "./Store/Variable";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import AdviserSiteTagManager from "../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
interface IBuyWizardState extends IAccountContextWizardComponentState {}

export class BuyWizard extends AccountContextWizardComponent<IBuyWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(BuyStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        const data = BuyStore.getData();
        this.setState({
            isLoading: false,
            data: data,
        });
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        BuyAction.initBuyModel();

        const { addEvent } = new AdviserSiteTagManager();

        addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname,
                pageTitle: `${document.title} - Buy investments - ${productMap[getQueryParameters()["type"]]}`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (to == -1) {
            this.onExit();
        } 
        else {
            //save pension investment pathway when click Next
            if(to==2 && getQueryParameters()["type"]==SubAccountType.Npr)
            {
                this.setState({onPosting:true},()=>{
                    BuyAction.savePensionInvestmentPath(this.state.data,(res)=>
                    {
                    });
                })
            }

            BuyAction.goToNextStep(from, this.filterdata(), (d) => {
                this.setState({ onPosting: false });
                if (from === 0) {
                    if (d === undefined) {
                        this.setState({ errorMsg: d.map((ele) => ele.UserMessage), isShowErrorMsg: true });
                    } else {
                        this.setState({ data: d });
                        Navigator.navigateToAndPreserveQueryParameters(toUrl);
                    }
                } else if (from === 1) {
                    if (d && d.length > 0) {
                        this.setState({ errorMsg: d.map((ele) => ele.UserMessage), isShowErrorMsg: true });
                    } else {
                        Navigator.navigateToAndPreserveQueryParameters(toUrl);
                    }
                }
            });
        }
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onCancel() {
        this.onExit();
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        BuyAction.submit(this.filterdata(), (result) => {
            this.setState({ isSubmitting: false });
            if (!result.SubmissionSucceed) {
                this.setState({
                    active: true,
                    errorMsg: [`There was an error when processing Batch ${result.BatchId}.`],
                });
            }
        });
    }

    filterdata(): any {
        const data = Objects.cloneObject(this.state.data);
        data.InvestmentList = data.InvestmentList.filter(item => item.Instrument.ProductCode !== "GBPCash")
        return data;
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);

        this.stepperConfig = [
            {
                title: buyStepperName.orderStep,
                url: Urls.get().BuyOrderSetup,
                path: Contents.URLMap.orderSetup,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <BuyOrderSetup {...this.getStepProps(0)} type={type} />,
            },
            {
                title: buyStepperName.ist,
                url: Urls.get().BuyInvestmentSelection,
                path: Contents.URLMap.ist,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <BuyInvestment {...this.getStepProps(1)} type={type} />,
            },
            {
                title: buyStepperName.review,
                url: Urls.get().BuyReview,
                path: Contents.URLMap.review,
                onSubmit: () => this.onSubmit(),
                needPrint: true,
                canSubmit: () => this.child[2].isValid(),
                component: (
                    <Review
                        {...this.getStepProps(2)}
                        type={type}
                        onClearError={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    />
                ),
            },
            {
                title: buyStepperName.confirmation,
                url: Urls.get().BuyConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => {
                            this.state.errorMsg.length > 0 || !checkPermission(UserClaim.AdviserPortalDluOrdersCanView)
                                ? Navigator.navigateToAndPreserveQueryParameters(Urls.get().BuyReview)
                                : (window.location.href = `/clients/orders/orders.aspx?claccountid=${this.state.clientAccount?.HeadClAccountId}`);
                        }}
                        buttonLabel={this.state.errorMsg.length > 0 ? "Previous" : "Go to transactions"}
                        errorMsg={this.state.errorMsg[0]}
                        successMessage={`We've received your instruction to buy investments for ${this.state.customer?.PersonalDetails?.Name.Given} ${this.state.customer?.PersonalDetails?.Name.Family} (${this.state.clientAccount?.HeadClAccountId}).`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Buy investments";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.subTitle = productMap[getQueryParameters()["type"]];
        return processProps;
    }
}
